import { BehaviorSubject, Observable, combineLatest, map, of } from "rxjs";

import { WISHLIST_ITEMS_FILTERING_TYPE, WishlistFilterItem } from "../types";

class WishlistFilterManager {
    private filterItems: WishlistFilterItem[];
    private currentFilterValues$: BehaviorSubject<
        WISHLIST_ITEMS_FILTERING_TYPE[]
    >;
    private selectedFilterItems$: Observable<WishlistFilterItem[]>;

    constructor({
        labelTranslationNamespace,
    }: {
        labelTranslationNamespace: string;
    }) {
        this.filterItems = [
            {
                value: WISHLIST_ITEMS_FILTERING_TYPE.all,
                labelTranslationKey: "filter_all",
                labelTranslationNamespace: labelTranslationNamespace,
            },
            {
                value: WISHLIST_ITEMS_FILTERING_TYPE.available,
                labelTranslationKey: "filter_available",
                labelTranslationNamespace: labelTranslationNamespace,
            },
        ];

        this.currentFilterValues$ = new BehaviorSubject<
            WISHLIST_ITEMS_FILTERING_TYPE[]
        >([WISHLIST_ITEMS_FILTERING_TYPE.all]);

        this.selectedFilterItems$ = this.currentFilterValues$.pipe(
            map((currentFilterValues) =>
                this.filterItems.filter((item) =>
                    currentFilterValues.includes(item.value)
                )
            )
        );
    }

    selectCurrentFilterValues() {
        return this.currentFilterValues$.asObservable();
    }

    getFilterItems() {
        return this.filterItems;
    }

    selectSelectedFilterItems() {
        return this.selectedFilterItems$;
    }

    setFilter(values: WISHLIST_ITEMS_FILTERING_TYPE[]) {
        this.currentFilterValues$.next(values);
    }
}

export default WishlistFilterManager;
